import { Router } from '@angular/router';
import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { AuthService } from '../../../../core/auth/auth.service';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { ViewDataTableService } from '../view-data-widget/view-data-table.service';

export abstract class ItemizedWidgetData {
  constructor(protected viewDataTableService: ViewDataTableService, protected router: Router, protected authService: AuthService) { }

  protected abstract createColumns(): TableColumn[];
  public abstract setFilterParameter(widget: Widget, widgetParameter: WidgetParameter, reset: boolean): void;
  public abstract createTableConfig(): TableConfig;
  public abstract createOverallTableHeaderColumn(): TableColumn;

  protected initializeTableConfig(): TableConfig {
    const tableConfig = new TableConfig();
    tableConfig.showHeader = false;
    tableConfig.enableAdd = false;
    tableConfig.enableEdit = false;
    tableConfig.enableDelete = false;
    tableConfig.enableFiltering = true;
    tableConfig.enableSorting = false;
    tableConfig.rowsPerPage = 5;
    tableConfig.lazyLoading = true;
    return tableConfig;
  }
}
